import React, { useEffect, useState } from "react";
import { Card, Typography as typography_antd } from "antd";
import { toast } from "react-toastify";
import {
  Typography,
  InputAdornment,
  OutlinedInput,
  IconButton,
  Button,
  FormHelperText,
} from "@mui/material";
import ApplyLeaveStyle from "../Components/ApplyLeaveStyle";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import env from "../config/env";
import { jwtDecode } from "jwt-decode";
import { logout, setToken, setUserData } from "../redux/slice/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import CryptoJS from "crypto-js";

const { Title } = typography_antd;

export default function ChangePassword() {
  const token = useSelector((state) => state.auth.token);

  let decode = jwtDecode(token);
  let userId = decode?.id;
  const [userDefaultDetails, setUserDefaultDetails] = useState(null); // Initialize with null
  const [preventDoubleClick, setPreventDoubleClick] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [inputData, setInputData] = useState({
    old_password: "",
    new_password: "",
    confirm_new_password: "",
  });
  const [oldErrorMessage, setOldErrorMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [errorConfirmMessage, setErrorConfirmMessage] = useState("");

  const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;

  const dispatch = useDispatch();

  const pattern =
    /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{8,18}$/;

  const onFinish = async () => {
    let oldPasswordError = "";
    let newPasswordError = "";
    let confirmPasswordError = "";

    if (inputData.old_password === "") {
      oldPasswordError = "Please Input Old Password";
    }
    //    else if(!pattern.test(inputData.old_password)){
    //   oldPasswordError =
    //   "Must contain at least one capital letter and one number and a special character and it has 8 to 18 characters.";
    // }
    if (inputData.new_password === "") {
      newPasswordError = "Please Input New Password";
    } else if (!pattern.test(inputData.new_password)) {
      newPasswordError =
        "Must contain at least one capital letter and one number and a special character and it has 8 to 18 characters.";
    }

    if (inputData.confirm_new_password === "") {
      confirmPasswordError = "Please input Confirm Password!";
    } else if (inputData.new_password !== inputData.confirm_new_password) {
      confirmPasswordError = "Confirm Password does not match with password!";
    }

    // Set the error messages
    setOldErrorMessage(oldPasswordError);
    setErrorMessage(newPasswordError);
    setErrorConfirmMessage(confirmPasswordError);

    // If there are no errors, proceed with changing the password

    if (!newPasswordError && !confirmPasswordError) {
      try {

        const data = {
          userId: userId,
          oldPassword: inputData.old_password,
          newPassword: inputData.new_password
        }

        // Encrypt data
        const encryptedBody = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();;

        //Encrypt api endpoint
        const changePassword = CryptoJS.SHA256("/changePassword" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

        const response = await fetch(
          `${env.backend_api_endpoint}/${changePassword}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ encryptedData: encryptedBody }),
          }
        );
        console.log(response.ok, "resp");
        if (!response.ok) {
          const responseData = await response.json();
          if (responseData.status === 400) {
            toast.error("Old Password is incorrect !", {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "1",
            })
          }
        }
        if (response.ok) {
          const successData = await response.json();
          if (successData.status === 200) {
            toast.success("Password Changed successfully !", {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "1",
            });


            // Clear input fields and error messages
            setConfirmPassword("");
            setPassword("");
            setInputData({
              old_password: "",
              new_password: "",
              confirm_new_password: "",
            });
          }
          if (successData.status === 555 || successData.status === 501) {
            dispatch(setToken(null));
            dispatch(setUserData(null));
            toast.error("Session expire, Please LogIn!", {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "1",
            });
            Navigate("/login")
          }
        }
      } catch (error) {
        console.error("Error Changes Password in:", error.message);
      }
    }
    setPreventDoubleClick(false);
  };
  const handleClickShowOldPassword = () => setShowOldPassword((show) => !show);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickConfirmShowPassword = () =>
    setShowConfirmPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <ApplyLeaveStyle>
      <div className="site-card-border-less-wrapper">
        <Card
          bordered={false}
          bodyStyle={{ height: "calc(100vh - 75px)", padding: "10px" }}
          style={{
            margin: 10,
          }}
        >
          <div
            style={{
              display: "flex",
              marginTop: "3px",
              marginBottom: "5px",
              fontFamily: "ImportedMilliardBold",
            }}
          >
            <Title
              level={2}
              style={{ color: "#244DA0", fontFamily: "ImportedMilliardBold", fontWeight: 500 }}
            >
              Change Password
            </Title>
          </div>
          <div className="changed_password">
            <Typography className="label_text_profile">
              Old Password:{" "}
            </Typography>
            <OutlinedInput
              placeholder="Old Password"
              value={inputData.old_password}
              type={showOldPassword ? "text" : "password"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowOldPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showOldPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
              onChange={(e) => {
                setOldErrorMessage("");
                setInputData({ ...inputData, old_password: e.target.value });
              }}
              size="small"
              autoComplete="off"
            />
            <FormHelperText id="helper_text">
              {oldErrorMessage ? oldErrorMessage : ""}
            </FormHelperText>
          {/* </div>
          <div className="changed_password"> */}
            <Typography className="label_text_profile">
              New Password:{" "}
            </Typography>
            <OutlinedInput
              placeholder="New Password"
              value={inputData.new_password}
              type={showPassword ? "text" : "password"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
              onChange={(e) => {
                setErrorMessage("");
                setInputData({ ...inputData, new_password: e.target.value });
              }}
              size="small"
              autoComplete="off"
            />
            <FormHelperText id="helper_text">
              {errorMessage ? errorMessage : ""}
            </FormHelperText>
            <Typography
              className="label_text_profile"
              style={{ marginTop: "10px" }}
            >
              Confirm New Password:{" "}
            </Typography>
            <OutlinedInput
              placeholder="Confirm New Password"
              value={inputData.confirm_new_password}
              type={showConfirmPassword ? "text" : "password"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickConfirmShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
              onChange={(e) => {
                setErrorConfirmMessage("");
                setInputData({
                  ...inputData,
                  confirm_new_password: e.target.value,
                });
              }}
              size="small"
              autoComplete="off"
            />
            <FormHelperText id="helper_text">
              {errorConfirmMessage}
            </FormHelperText>
            <Button
              size="large"
              type="primary"
              block
              variant="contained"
              id="submit_btn"
              onClick={onFinish}
              disabled={preventDoubleClick}
              style={{
                marginTop: "33px",
                background: "#244DA0",
                borderRadius: "6px",
                fontFamily: "MilliardMedium",
                textTransform: "none",
              }}
            >
              Change Password
            </Button>
          </div>
        </Card>
      </div>
    </ApplyLeaveStyle>
  );
}
